import React from 'react';
import { Col, Row } from 'reactstrap';

import KStatus from '../base/data/KStatus';
import C from '../C';

import Misc from '../base/components/Misc';
import { getDataList, setWindowTitle } from '../base/plumbing/Crud';
import List from '../base/data/List';
import { ImpactCreditListItem } from './ImpactCreditPage';
import { ImpactDebitListItem } from './ImpactDebitPage';


function ImpactAllocationPage() {
    setWindowTitle("Allocation");
    const blocked = Misc.CheckAccess({ can: 'editImpact' });
    if (blocked) return blocked;

    let start, end;
    let qc,qd;
    
    // list of credits
    let pvCreditList = getDataList({type:C.TYPES.ImpactCredit, status:KStatus.ALL_BAR_TRASH, q:qc, start, end});
    let pvDebitList = getDataList({type:C.TYPES.ImpactDebit, status:KStatus.ALL_BAR_TRASH, q:qd, start, end});
    
    if ( ! pvCreditList.value || ! pvDebitList.value) {
        return <Misc.Loading />;
    }

    let credits = List.hits(pvCreditList.value);
    let debits = List.hits(pvDebitList.value);
    console.log(credits, pvCreditList);
    return (<>
        <Row>
            <Col>
                <C.A href="/#impactdebit"><h3>Impact Debit</h3></C.A>
                {debits.map(debit => <div key={debit.id} className="btn btn-outline-secondary m-2 p-2"><ImpactDebitListItem item={debit} /></div>)}
            </Col>
            <Col>
                <C.A href="/#impactcredit"><h3>Impact Credit</h3></C.A>
                {credits.map(credit => <ImpactCreditListItem key={credit.id} item={credit} />)}
            </Col>
        </Row>
    </>);
}

export default ImpactAllocationPage;
